/* Doubled selector outranks LeafyGreen's runtime-injected Emotion styles.
   Remove when this component migrates to Via. */
.subtitle.subtitle {
  margin-bottom: var(--via-space-200);
}
